import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { EsignApiKeyService } from '../services/esign-api-key.service';

export const ESIGN_API_PREFIX = '/documents-api';

/**
 * Sends `x-api-key` (instead of the customer JWT) for every demo eSign call.
 *
 * Must run before {@link EnvironmentInterceptor}, which is what prefixes the
 * relative url with the environment base url.
 */
@Injectable()
export class EsignApiKeyInterceptor implements HttpInterceptor {

  constructor(private apiKeyService: EsignApiKeyService) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    if (!request.url.startsWith(ESIGN_API_PREFIX)) {
      return next.handle(request);
    }

    let headers = request.headers.delete('Authorization');
    const apiKey = this.apiKeyService.apiKey;

    if (apiKey) {
      headers = headers.set('x-api-key', apiKey);
    }

    return next.handle(request.clone({ headers }));
  }
}
